import QueryWhereNode from './query-where-node';
// eslint-disable-next-line import/no-cycle
import QueryWhereRule from './query-where-rule';

/**
 * @param {any} r
 * @param {?(QueryWhereNode | 'parent' | 'self')} node
 * @returns {QueryWhereRule | QueryWhereRules | undefined}
 */
const rulesMap = (r, node = null) => {
	let rule;
	// Un sous-groupe ET/OU porte sur la même classe que son groupe parent : il
	// doit transmettre le node à ses règles. Sans lui, getNode() est vide et
	// query-rule-operator ne peut pas calculer la liste des opérateurs — le
	// select s'affiche vide alors que la règle a bien un opérateur.
	if (r.field && !(r.field === 'none' && r.rules)) {
		// Le node est passé au constructeur, qui le transmet au sous-groupe éventuel
		// de la règle (`rules`). 'parent' désigne un groupe de classes, jamais la
		// classe d'une règle : il est écarté.
		const ruleNode = node instanceof QueryWhereNode || node === 'self' ? node : null;
		if (!ruleNode) {
			console.warn('no node!', node);
		}
		rule = new QueryWhereRule(r, ruleNode);
	}
	else if (r.rules) {
		// Sous-groupe selon la grammaire v3 : un élément sans `field` (ou avec
		// `field: 'none'`) qui porte `rules`.
		// eslint-disable-next-line no-use-before-define
		rule = new QueryWhereRules(r.rules, node);
	}
	else if (r.items) {
		// Ancienne forme exportée par l'éditeur : un `{condition, items}` nu, que le
		// backend ignore sans erreur. Relue pour que les requêtes enregistrées
		// ainsi soient réparées au prochain enregistrement (cf. exportRulesMap).
		// eslint-disable-next-line no-use-before-define
		rule = new QueryWhereRules(r, node);
	}
	return rule;
};

export default class QueryWhereRules {
	/** @type {?(QueryWhereNode | 'self')} */
	#node;

	/**
	 * @param {any} rules
	 * @param {?(QueryWhereNode | 'parent' | 'self')} node
	 */
	constructor(rules = null, node = null) {
		/** @type {'AND' | 'OR'} */
		this.condition = rules?.condition || 'AND';

		/** @type {(QueryWhereRule | QueryWhereRules)[]} */
		this.items = rules?.items?.map((/** @type {any} */ item) => rulesMap(item, node)) || [];

		this.#node = 'self';
	}

	/**
	 * @param {?QueryWhereNode | 'parent' | 'self'} node
	 */
	setParent(node) {
		if (node !== 'parent') {
			this.#node = node;
		}
	}
}
